const ENV = process.env.REACT_APP_ENV || "staging-api";

const stripProtocolAndSlash = (value) =>
  String(value || "")
    .trim()
    .replace(/^https?:\/\//i, "")
    .replace(/\/+$/, "");

const hostFromEnv = (() => {
  const host = stripProtocolAndSlash(ENV);
  if (!host) return "staging-api.credissuer.com";
  return host.includes(".") ? host : `${host}.credissuer.com`;
})();

const HTTPS_HOST =
  process.env.REACT_APP_HTTPS_HOST || `https://${hostFromEnv}/`;

const escapeForRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const AppConstants = {
  TENANT: { tenant: "Uganda" },
  ENTITY: { entity: "Exporter" },
  GOOGLE_CLIENT: { client_name: "google" },
  MICROSOFT_RESPONSE_TYPE: "code",
  MICROSOFT_RESPONSE_MODE: "query",
  MICROSOFT_SCOPE: "openid email profile offline_access User.Read",
  MICROSOFT_STATE: "12345",
  MICROSOFT_GRANT_TYPE: "authorization_code",
  MICROSOFT_CLIENT: "microsft",
  MICROSOFT_REDIRECT_URI: "https://verify.credissuer.com/",
  TRUSTED_IIITB_HOSTS: [
    "https://iiitb-verify.credissuer.com",
    "https://verify.iiitb.ac.in",
  ],
  CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
  MICROSOFT_CLIENT_ID: process.env.REACT_APP_MICROSOFT_CLIENT_ID || "",
  GOOGLE_CAPTCHA_SITE_KEY: process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY || "",
  HTTPS_HOST,
  HTTPS_HOST_API: `${HTTPS_HOST.replace(/\/+$/, "")}/api`,
  HOST: "localhost",
  HOST_REGEX: new RegExp(
    `^${escapeForRegExp(
      HTTPS_HOST.replace(/\/+$/, "").replace(/\/api$/, ""),
    )}/api`,
  ),
};

export default AppConstants;
